import * as React from 'react'
// import Socket from '../../../Socket/socket-init'
// import { Logic } from '../../../Logic/Type'
// import { Main } from '../../../Logic/Main'
import { Link, withRouter, Redirect } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import Socket from '../../../Socket/socket-init'
import * as Assets from '../../../assets/Assets'
import * as Body from './Body'
import * as Utils from '../../../Logic/Utils'
import * as RouteClasses from '../../../Socket/route-classes'
import Loader from './Loader'

interface IProps {
    mobileMenu: boolean
    userDropdown: boolean
    username: string
    password: string
    passwordConfirmation: string
    listen: boolean
}

export class MyProfile extends React.Component<{}, IProps> {

    public cookies
    
    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = {
            mobileMenu: false,
            userDropdown: false,
            username: '',
            password: '',
            passwordConfirmation: '',
            listen: true
        }

        Socket.Send('flags', {})
        Socket.Send('my-profile-select', {username: this.cookies.get('username')})
    }

    handleInput(value: string, state: string) {
        this.state[state] = value
        this.setState(this.state)
    }

    updateUser() {
        event.preventDefault()
        if (this.state.username === '') {
            alert('Write your Username.')
        } else if (this.state.password === '') {
            alert('Write your Password.')
        } else {
            const user: RouteClasses.IUser = {
                username: this.state.username,
                password: this.state.password,
            }
            Socket.Send('my-profile-update', {user, username: this.cookies.get('username')})
        }
    }

    componentWillReceiveProps() {
        if (this.state.listen) {
            if (Socket.Get<any>('my-profile-select').loading === 'loaded') {
                const user = Socket.Get<any>('my-profile-select').myProfileSelect
                this.setState({
                    username: user.username
                })
                this.setState({ listen: false })
            }
        }
    }

    render() {
        const user = Socket.Get<any>('my-profile-select')
        if (user.loading !== 'loaded') {
            return <Loader/>
        } else {
            const userUpdate = Socket.Get<any>('my-profile-update')
            if (userUpdate.myProfileUpdate && userUpdate.myProfileUpdate.id) {
                Socket.Set('my-profile-update', {})
                Utils.logout()
                return <Redirect to="/login"/>
            }
            return(
                <div>
                    <section className="wrapper">
                        <div className="header" role="banner">
                            <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                                <div className="container">
                                    <div className="navbar-header">
                                        <button 
                                            onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                            type="button" 
                                            className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                            data-toggle="collapse" 
                                            data-target="#navbar-collapse-mid" 
                                            aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                        >
                                        <span className="sr-only">Toggle navigation</span>
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        </button>                                  
                                        <Link className="navbar-brand" to="/">
                                        <img src={Assets.logoMain} alt="" className="logo" />
                                        </Link> 
                                        <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                    </div>
                                    <nav 
                                        className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                        id="navbar-collapse-left"
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                        style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                    >
                                        {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                    </nav>
                                    <nav className="collapse navbar-collapse" id="user-profile">
                                        <ul className="nav navbar-nav navbar-right">
                                            <li className="user-nav-option">
                                                <div className="user">
                                                    <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                        <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                            <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            {(this.cookies.get('username')) ? 
                                            <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                                <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                    <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                                </a>
                                                <ul className="dropdown-menu">
                                                        <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                        <li onClick={() => Utils.logout()}>
                                                        <Link to="/login">
                                                            <i className="icon-logout"/>
                                                            LOGOUT
                                                        </Link>
                                                        </li>
                                                </ul>
                                            </li>
                                            :
                                            null}
                                        </ul>
                                    </nav>
                                </div>
                            </header>
                        </div>
                        <div className="info-ribbon">
                            <div className="container">
                                <div className="h4 text-center">MY PROFILE</div>
                            </div>
                        </div>
                        <main className="main">
                            <div className="container">
                                <div className="panel panel-default limited-width">
                                    <div className="panel-body">
                                        <div className="profile-pic-wrapper">
                                            <div className="profile-pic">
                                                <div className="panel-profile-pic">
                                                    <img src="user-profile.png" alt="" className="img-circle"/>                                        
                                                </div>
                                            </div>  
                                        </div> 
                                        <div className="profile-pic-wrapper-clone"/>
                                        <div className="clearfix"/>
                                        <h4 style={{ marginBottom: '30px' }}><i>Edit your username or password below</i></h4>
                                        <form>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className={((userUpdate.myProfileUpdate && userUpdate.myProfileUpdate.usernameError) || (userUpdate.myProfileUpdate && userUpdate.myProfileUpdate.bothError)) ? 'form-group has-error' : 'form-group'}>
                                                        <span>Username</span>
                                                        <input type="text" className="form-control" placeholder="" value={this.state.username} onChange={(event) => this.handleInput(event.target.value, 'username')} />
                                                        <span className="error-block"><span>Username already exists</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <span>Password</span>
                                                        <input type="password" className="form-control" placeholder="" value={this.state.password} onChange={(event) => this.handleInput(event.target.value, 'password')} />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className={(this.state.password === this.state.passwordConfirmation) ? 'form-group' : 'form-group has-error'}>
                                                        <span>Confirm Password</span>
                                                        <input type="password" className="form-control" placeholder="" value={this.state.passwordConfirmation} onChange={(event) => this.handleInput(event.target.value, 'passwordConfirmation')} />
                                                        <span className="error-block"><span>Passwords do not match</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row btn-wrapper mT20">
                                                <div className="col-sm-6" style={{ float: 'none', margin: '0 auto' }}>
                                                    <a className="btn-primary btn-lg no-shadow btn-block btn" onClick={() => this.updateUser()}>SAVE</a>
                                                </div>
                                            </div>
                                        </form>                
                                    </div>
                                </div>
                            </div>
                        </main>
                    </section>
                </div>
            )
        }
    }
}

withCookies(MyProfile)
withRouter(MyProfile)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/MyProfile.tsx